import bootstrap from "shared/bootstrap";
import baseManifest from "modules/base";
import portalManifest from "./portal-manifest";
import envLoader from "shared/env-loader";
import relationprofile from "modules/relationprofile";
import projects from "modules/projects";
import manuals from "modules/manuals";
import feedback from "modules/feedback";
import contact from "modules/contact";
import credentials from "customer-modules/b2bplaza/credentials";
import invoices from "customer-modules/b2bplaza/invoices";
import c3x from "customer-modules/b2bplaza/c3x";

const vuetify = {
  theme: {
    primary: "#2f71a6",
    secondary: "#5c95ba",
    accent: "#91c61c",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  }
};

bootstrap({
  title: "Mijn B2B Plaza",
  vuetify,
  modules: [
    baseManifest,
    portalManifest,
    relationprofile,
    projects,
    invoices,
    credentials,
    manuals,
    feedback,
    contact,
    c3x
  ],
  axios: {
    baseURL: envLoader("API_URL", "/"),
    withCredentials: true
  },
  customToolbar: [
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/feedback/components/ToolbarFeedbackAction.vue"),
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/contact/components/GlobalContactButton.vue"),
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../customer-modules/b2bplaza/c3x/components/ButtonLoader")
  ]
});
